import React from 'react'

const ProjectCard = ({
    img,
    title,
    desc,
    techs
}) => {
    return <div class="max-w-sm bg-light rounded-lg border  shadow-md text-dark">
        <div className='md:h-56 overflow-y-hidden'>
            <img class="rounded-t-lg  w-full" src={img} />
        </div>
        <div class="p-5">
            <h5 class="mb-2 md:text-2xl text-xl font-bold tracking-tight ">{title}</h5>
            <p class="mb-3 font-normal  md:text-base text-sm md:h-28">{desc}</p>
            <div className='flex gap-3 flex-wrap'>
                {techs.map(item => <span class="inline-flex items-center py-2 px-3 text-sm font-medium text-center text-light bg-danger rounded-lg  focus:ring-4 focus:outline-none  ">
                    {item}
                </span>)}
            </div>
        </div>
    </div>
}

export default ProjectCard